<section *ngIf="!mobileView">
    <div style="justify-content: flex-end;">
        <div class="dropdownMenu d-inline-block">
            <button class="btn btn-primary d-flex align-items-center">
                <i class="fas fa-download" style="font-size: 14px; margin-right: 6px;"></i>
                <span class="add-btn-text">Export</span>
            </button>
            <ul class="dropdownMenu-content"  (click)="onSelectionChange($event)" >
                @for (item of exportFormatReference | enumToArray; track $index) {
                    <option class="dropdownMenu-content-option" [selected]="item?.value === selectedExportOption" [value]="item?.value" [text]="item?.name" (click)="onExportClick($event,item?.name )">{{item.name}}</option>
                }
            </ul>
        </div>
    </div>
</section>

    <section *ngIf="mobileView">
        <div class="row">
            <div class="col-md-6">
                <div class="dropdownMenu d-inline-block mt-1">
                    <button class="btn btn-primary d-flex align-items-center">
                        <i class="fas fa-download" style="font-size: 14px; margin-right: 6px;"></i>
                        <span class="add-btn-text">Export</span>
                    </button>
                    <ul class="dropdownMenu-content" style="text-align:center;top: 37px;">
                <button type="button" class="btn" data-toggle="modal" data-target=".export-modal"><span
                        class="dropdownMenu-content-option"><a
                            (click)="toggleExport('excel')">Excel</a></span></button>
                <button type="button" class="btn d-flex" style="position: relative;padding-left: 35px;"
                    data-toggle="modal" data-target=".export-modal"><span class="dropdownMenu-content-option"><a
                            (click)="toggleExport('pdf')">PDF</a></span></button>
            </ul>
        </div>
        </div>
        </div>
    </section>
    <p-dialog [(visible)]="mobileView" [closeOnEscape]="false" [modal]="true" [draggable]="false" [resizable]="false" *ngIf="mobileView"
    [style]="{ height: '25rem' }">
    <p-header>
        <h3>List</h3>
    </p-header>
    <div>
        <app-common-list (setValues)="selecetdRow($event)" [columns]="columns" [rowSelection]="'multiple'"
            [suppressContextMenu]="true" [gridData]="data"
            (hideModal)="toggleList()"></app-common-list>
    </div>
</p-dialog>